namespace  info.imagelogic.Ajax{
	export function get(url):Promise<any>{
		return new Promise((resolve, reject) => {
			let req = new XMLHttpRequest();
			req.open("GET", url);
			req.onload = () => {

				if(req.status == 200){
					// IE9 doesn't have req.response,
					// use req.responseText instead
					resolve(req.responseText);
				}else{
					console.log("rejected");
					reject(Error(req.statusText));

				}
			};
			req.onerror = () => {
				reject(Error("Network Error"));
			};
			req.send();
		});
	}

	export function getJSON(url:string):Promise<any>{
		return get(url).then(JSON.parse);
	}
}

